import script from "./ApplicationDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationDetailView.vue?vue&type=style&index=0&id=4819befc&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4819befc"]])

export default __exports__